//ShareMap.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";

import { Button, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

//Show the dialog.
export function show() {
   Util.logMsg("Showing share map");

   if (!Settings.dialogDivRoot) {
      Settings.setDialogDivRoot(ReactDOM.createRoot(document.getElementById("dialog_div")));
   }
   Settings.dialogDivRoot.render(<Render key={Util.uid()} />);
}

//Render function.
export function Render() {

   //Define state.
   const [visible, setVisible] = React.useState(true); //Set refresh method.

   const linkRef = React.useRef<HTMLInputElement | null>(null);
   const embedRef = React.useRef<HTMLInputElement | null>(null);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Close dialog.
   function handleClose() {
      setVisible(false);
   }

   function copyLinkToClipboard(event: React.MouseEvent<HTMLButtonElement>) {
      copyToClipboard(event, linkRef);
   }

   function copyEmbedToClipboard(event: React.MouseEvent<HTMLButtonElement>) {
      copyToClipboard(event, embedRef);
   }

   function copyToClipboard(event: React.MouseEvent<HTMLButtonElement>, elemRef: React.MutableRefObject<HTMLInputElement>) {
      elemRef.current.select();
      navigator.clipboard.writeText(elemRef.current.value);
      event.currentTarget.focus();
      SnackBar.show("Copied to clipboard", 2);
   }

   //Build links.
   let link: string = Settings.webServerURL + "/" + Settings.webSitePath;

   if (Search.activePIN === "") {
      const me: __esri.Extent = MainMap.activeView.extent;
      link += "?MapExtent=" + Math.round(parseFloat(me.xmin.toString())) + "," + Math.round(parseFloat(me.ymin.toString())) + "," +
         Math.round(parseFloat(me.xmax.toString())) + "," + Math.round(parseFloat(me.ymax.toString())) + "," + me.spatialReference.wkid;

   } else {
      link += "?pin=" + Search.activePIN;
   }

   link = link.replace(/ /g, "+");
   const embedLink: string = '<a href="' + link + '" target="_blank" aria-label="GIS Website">GIS Website</a>';

   //css styles.
   const styles: Default.iStyles = {
      row1Container: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', padding: 5, backgroundColor: Settings.leftPanelLabelColor },
      col1Container: { display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginRight: 20 },
      input: { width: 300, fontSize: 14, marginTop: 5, border: 0, backgroundColor: Settings.leftPanelLabelColor },
   };

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />
         <Dialog
            role="dialog"
            aria-modal="true"
            id="share-dialog"
            open={visible}
            onClose={handleClose}
            aria-label="Share Map"
            aria-labelledby="share-map-title"
            aria-describedby="share-map-description"
         >
            <DialogTitle id="share-map-title" style={{ paddingBottom: 0, paddingTop: 9 }}>
               Share Map
            </DialogTitle>

            <DialogContent id="share-map-description">
               <Paper style={styles.row1Container}>
                  <div style={styles.col1Container}>
                     <div>
                        <Typography variant="body1">To share this map, copy and paste the link</Typography>
                     </div>

                     <div>
                        <input id="share-link" style={styles.input} type="text" ref={linkRef} value={link} readOnly aria-label="Share link" />
                     </div>
                  </div>

                  <div>
                     <Button variant="outlined" color="info" size="medium" onClick={copyLinkToClipboard} title="Copy link to clipboard" aria-label="Copy link">
                        Copy Link
                     </Button>
                  </div>
               </Paper>

               <br />

               <Paper style={styles.row1Container}>
                  <div style={styles.col1Container}>
                     <div>
                        <Typography variant="body1">To embed in a website</Typography>
                     </div>

                     <div>
                        <input id="embed-link" style={styles.input} type="text" ref={embedRef} value={embedLink} readOnly aria-label="Embed link" />
                     </div>
                  </div>

                  <div>
                     <Button variant="outlined" color="info" size="medium" onClick={copyEmbedToClipboard} title="Copy link to clipboard" aria-label="Copy link">
                        Copy Link
                     </Button>
                  </div>
               </Paper>

            </DialogContent>

            <DialogActions>
               <Button onClick={handleClose} color="info">
                  Close
               </Button>
            </DialogActions>
         </Dialog>
      </ThemeProvider>
   ); //end return.

} //end function.
